import React, { useState } from "react";
import { Link } from "gatsby";
import appData from "data/app.json";
import { handleMobileDropdown } from "common/navbar";
import DarkImg from "../../../static/img/dark-mode-6682.svg";
import LightImg from "../../../static/img/sun-8761.svg";
import { useStaticQuery, graphql } from "gatsby"; // Import useStaticQuery and graphql
import JobModal from "components/JobModal";
import { Button } from "react-bootstrap";
import { GetOppturtunities } from "components/ApiServices/GetOppturtunitiesData";

const Navbar = ({ lr, nr, theme, themeModeChange }) => {
  const data = useStaticQuery(graphql`
    query {
      allWpService {
        nodes {
          title
          slug
          technologiesData {
            nodes {
              title
              slug
            }
          }
        }
      }
    }
  `);
  const oppturtunitiesData = GetOppturtunities();
  const [modalShow, setModalShow] = useState(false);
  const services = data.allWpService.nodes;

  return (
    <>
      <nav
        ref={nr}
        className={`navbar navbar-expand-lg change ${
          theme === "themeL" ? "light" : ""
        }`}
      >
        <div className="container-fluid">
          <div className="container-fluid d-flex justify-content-between">
            <Link to="/" className="logo">
              <img
                className="img-responsive"
                loading="lazy"
                ref={lr}
                src={theme === "themeL" ? appData.darkLogo : appData.lightLogo}
                alt="Evolvan logo"
              />
            </Link>

            <div className="d-flex align-items-center">
              <button
                className="navbar-toggler"
                type="button"
                onClick={handleMobileDropdown}
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar">
                  <i className="fas fa-bars"></i>
                </span>
              </button>

              <div
                className="nav-menu-one collapse navbar-collapse pr-3 justify-content-end"
                id=""
              >
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link
                      to={`/`}
                      className="nav-link"
                      onClick={() => {
                        checkPaceClass();
                      }}
                    >
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to={`/about`}
                      onClick={() => {
                        checkPaceClass();
                      }}
                      className="nav-link"
                    >
                      About
                    </Link>
                  </li>
                  <li id="rservices" className="nav-menu desktop-menu">
                    <li className="nav-item">
                      <Link
                        to="/services"
                        onClick={() => {
                          checkPaceClass();
                        }}
                        className="nav-link"
                      >
                        Services
                      </Link>
                    </li>

                    <div id="rsubmenu" className="submenu">
                      {services.map((service) => (
                        <div className="submenus-list" key={service.slug}>
                          <li className="rsubmenu">
                            <Link
                              to={`/services/${service.slug}`}
                              state={{ selectedService: service.slug }}
                              onClick={() => {
                                checkPaceClass();
                              }}
                            >
                              <strong>{service.title}</strong>
                            </Link>
                            {service?.technologiesData?.nodes.length > 0 && (
                              <ul className="rsubmenu-list">
                                {service.technologiesData?.nodes.map(
                                  (technologiesData) => (
                                    <li key={technologiesData.slug}>
                                      <Link
                                        to={`/services/${service.slug}/${technologiesData.slug}`}
                                        onClick={() => {
                                          checkPaceClass();
                                        }}
                                        state={{
                                          selectedTechnology:
                                            technologiesData.slug,
                                        }}
                                      >
                                        {technologiesData.title}
                                      </Link>
                                    </li>
                                  ),
                                )}
                              </ul>
                            )}
                          </li>
                        </div>
                      ))}
                    </div>
                  </li>
                  <li id="rservices" className="nav-menu tab-mobile-menu">
                    <li className="nav-item">
                      <Link
                        onClick={() => {
                          checkPaceClass();
                        }}
                        to="/services"
                        className="nav-link"
                      >
                        Services
                      </Link>
                    </li>
                    <div id="rsubmenu" className="submenu">
                      {services.map((service) => (
                        <div className="submenus-list" key={service.slug}>
                          <li className="rsubmenu">
                            <Link
                              to={`/services/${service.slug}`}
                              state={{ selectedService: service.slug }}
                              onClick={() => {
                                checkPaceClass();
                              }}
                            >
                              <strong>{service.title}</strong>
                            </Link>
                            <br />
                          </li>
                        </div>
                      ))}
                    </div>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to={`/work`}
                      className="nav-link"
                    >
                      Work
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to={`/case-studies`}
                      className="nav-link"
                    >
                      Case Studies
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to={`/blog`}
                      className="nav-link"
                    >
                      Blogs
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to={`/career`}
                      className="nav-link"
                    >
                      Career
                    </Link>
                  </li>
                  <li className="nav-item ">
                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to={`/contact`}
                      className="nav-link"
                    >
                      Contact
                    </Link>
                  </li>

                  <li className="nav-item">
                    {theme === "themeL" ? (
                      <button
                        className="change-theme-mode"
                        onClick={() => themeModeChange("themeL")}
                        aria-label="Switch to dark theme"
                      >
                        <img
                          loading="lazy"
                          src={DarkImg}
                          style={{ width: "30px", height: "65px" }}
                          alt=""
                          aria-hidden="true"
                        />
                      </button>
                    ) : (
                      <button
                        className="change-theme-mode"
                        onClick={() => themeModeChange("Dark")}
                        aria-label="Switch to light theme"
                      >
                        <img
                          loading="lazy"
                          src={LightImg}
                          style={{
                            filter: "invert(1)",
                            width: "30px",
                            height: "65px",
                          }}
                          alt=""
                          aria-hidden="true"
                        />
                      </button>
                    )}
                  </li>
                </ul>
              </div>

              <Button
                variant="primary"
                className="nb butn bord apply-btn drop-cv-btn"
                onClick={() => setModalShow(true)}
              >
                Drop your CV
              </Button>
            </div>
          </div>

          <div
            className="nav-menu-two collapse navbar-collapse pr-3 justify-content-end"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  to={`/`}
                  className="nav-link"
                  onClick={() => {
                    checkPaceClass();
                  }}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to={`/about`}
                  onClick={() => {
                    checkPaceClass();
                  }}
                  className="nav-link"
                >
                  About
                </Link>
              </li>
              <li id="rservices" className="nav-menu desktop-menu">
                <li className="nav-item">
                  <Link
                    to="/services"
                    onClick={() => {
                      checkPaceClass();
                    }}
                    className="nav-link"
                  >
                    Services
                  </Link>
                </li>

                <div id="rsubmenu" className="submenu">
                  {services.map((service) => (
                    <div className="submenus-list" key={service.slug}>
                      <li className="rsubmenu">
                        <Link
                          to={`/services/${service.slug}`}
                          state={{ selectedService: service.slug }}
                          onClick={() => {
                            checkPaceClass();
                          }}
                        >
                          <strong>{service.title}</strong>
                        </Link>
                        {service?.technologiesData?.nodes.length > 0 && (
                          <ul className="rsubmenu-list">
                            {service.technologiesData?.nodes.map(
                              (technologiesData) => (
                                <li key={technologiesData.slug}>
                                  <Link
                                    to={`/services/${service.slug}/${technologiesData.slug}`}
                                    onClick={() => {
                                      checkPaceClass();
                                    }}
                                    state={{
                                      selectedTechnology: technologiesData.slug,
                                    }}
                                  >
                                    {technologiesData.title}
                                  </Link>
                                </li>
                              ),
                            )}
                          </ul>
                        )}
                      </li>
                    </div>
                  ))}
                </div>
              </li>
              <li id="rservices" className="nav-menu tab-mobile-menu">
                <li className="nav-item">
                  <Link
                    onClick={() => {
                      checkPaceClass();
                    }}
                    to="/services"
                    className="nav-link"
                  >
                    Services
                  </Link>
                </li>
                <div id="rsubmenu" className="submenu">
                  {services.map((service) => (
                    <div className="submenus-list" key={service.slug}>
                      <li className="rsubmenu">
                        <Link
                          to={`/services/${service.slug}`}
                          state={{ selectedService: service.slug }}
                          onClick={() => {
                            checkPaceClass();
                          }}
                        >
                          <strong>{service.title}</strong>
                        </Link>
                        <br />
                      </li>
                    </div>
                  ))}
                </div>
              </li>
              <li className="nav-item">
                <Link
                  onClick={() => {
                    checkPaceClass();
                  }}
                  to={`/work`}
                  className="nav-link"
                >
                  Work
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  onClick={() => {
                    checkPaceClass();
                  }}
                  to={`/case-studies`}
                  className="nav-link"
                >
                  Case Studies
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  onClick={() => {
                    checkPaceClass();
                  }}
                  to={`/blog`}
                  className="nav-link"
                >
                  Blogs
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  onClick={() => {
                    checkPaceClass();
                  }}
                  to={`/career`}
                  className="nav-link"
                >
                  Career
                </Link>
              </li>
              <li className="nav-item ">
                <Link
                  onClick={() => {
                    checkPaceClass();
                  }}
                  to={`/contact`}
                  className="nav-link"
                >
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                {theme === "themeL" ? (
                  <button
                    className="change-theme-mode"
                    onClick={() => themeModeChange("themeL")}
                    aria-label="Switch to dark theme"
                  >
                    <img
                      loading="lazy"
                      src={DarkImg}
                      style={{ width: "30px", height: "65px" }}
                      alt=""
                      aria-hidden="true"
                    />
                  </button>
                ) : (
                  <button
                    className="change-theme-mode"
                    onClick={() => themeModeChange("Dark")}
                    aria-label="Switch to light theme"
                  >
                    <img
                      loading="lazy"
                      src={LightImg}
                      style={{
                        filter: "invert(1)",
                        width: "30px",
                        height: "65px",
                      }}
                      alt=""
                      aria-hidden="true"
                    />
                  </button>
                )}
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <JobModal
        oppturtunityData={[oppturtunitiesData]}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Navbar;
